// import React from "react";
// import { styled } from "@mui/material/styles";
// import { Switch, Stack } from "@mui/material";
// import { useTranslation } from "react-i18next";
// import frFlag from "@assets/images/fr.png";
// import enFlag from "@assets/images/en.png";

// const ToggleSwitchStyled = styled(Switch)(({ theme }) => ({
//   width: "42px",
//   height: "16px",
//   padding: 7,
//   borderRadius: "24px",
//   border: "0.384px solid rgba(105, 178, 255, 0.15)",

//   background: "#0F84FF",
//   "& .MuiSwitch-switchBase": {
//     margin: 1,
//     padding: 0,
//     transform: "translateX(6px)",
//     "&.Mui-checked": {
//       transform: "translateX(22px)",
//       "& .MuiSwitch-thumb": {
//         backgroundImage: `url(${enFlag})`,
//       },
//       "& + .MuiSwitch-track": {
//         backgroundColor: theme.palette.mode === "dark" ? "#8796A5" : "#aab4be",
//         opacity: 1,
//       },
//     },
//   },
//   "& .MuiSwitch-thumb": {
//     backgroundColor: "#fff",
//     backgroundImage: `url(${frFlag})`,
//     backgroundSize: "cover",
//     backgroundPosition: "center",
//     width: 15,
//     height: 15,
//   },
//   "& .MuiSwitch-track": {
//     borderRadius: 20,
//     backgroundColor: "#aab4be",
//     opacity: 1,
//   },
// }));
import React from "react";
import { styled } from "@mui/material/styles";
import { Switch, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import frFlag from "@assets/images/fr.png";
import enFlag from "@assets/images/en.png";

const ToggleSwitchStyled = styled(Switch)(({ theme }) => ({
  width: 65,
  height: 34,
  padding: 7,
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 4,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(30px)",
      color: "#fff",
      "& .MuiSwitch-thumb": {
        backgroundImage: `url(${enFlag})`,
      },
      "& + .MuiSwitch-track": {
        backgroundColor: "#0F84FF",
        opacity: 1,
      },
    },
  },
  "& .MuiSwitch-thumb": {
    backgroundColor: "#fff",
    backgroundImage: `url(${frFlag})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    width: 26,
    height: 26,
    borderRadius: "50%",
    boxShadow: theme.shadows[1],
  },
  "& .MuiSwitch-track": {
    borderRadius: 20,
    backgroundColor: "#0F84FF",
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 500,
    }),
  },
}));
const ToggleSwitch = () => {
  const { i18n } = useTranslation();
  const isFrench = i18n.language === "fr";

  const handleToggle = () => {
    i18n.changeLanguage(isFrench ? "en" : "fr");
  };

  return (
    <Stack direction="row" alignItems="center">
      <ToggleSwitchStyled checked={!isFrench} onChange={handleToggle} />
    </Stack>
  );
};

export default ToggleSwitch;
